// config.js
const ENV = process.env.REACT_APP_ENV;

let backendURL;
let ChatScriptsURL;
let APPLICATION_URL;
let CUSTOMER_APPLICATION_URL;
let CHATBOT_UI;
let KLONIT_WEBSOCKET_URL;
let stripe_pub_key;
let google_login_api;
let facebook_app_id;
let linkedin_client_id;
let linkedin_redirect_uri;
if (ENV === "Development") {
    backendURL = process.env.REACT_APP_BACKEND_URL_DEVELOPMENT;
    ChatScriptsURL = process.env.REACT_APP_CHATBOT_UI_DEVELOPMENT;
    APPLICATION_URL = process.env.REACT_APP_APPLICATION_URL_DEVELOPMENT;
    CHATBOT_UI = process.env.REACT_APP_CHATBOT_UI_DEVELOPMENT;
    KLONIT_WEBSOCKET_URL = process.env.REACT_APP_KLONIT_WEBSOCKET_URL_DEVELOPMENT || 'ws://localhost:5005';
    stripe_pub_key =  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    google_login_api =  process.env.REACT_APP_GOOGLE_LOGIN_KEY;
    facebook_app_id =  process.env.REACT_APP_FACEBOOK_LOGIN_KEY;
    linkedin_client_id = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
    linkedin_redirect_uri = APPLICATION_URL + "/linkedin-callback";
    CUSTOMER_APPLICATION_URL = process.env.REACT_APP_CUSTOMER_URL_DEVELOPMENT;
} else if (ENV === "Production") {
    backendURL = process.env.REACT_APP_BACKEND_URL_PRODUCTION;
    ChatScriptsURL = process.env.REACT_APP_CHATBOT_UI_PRODUCTION;
    APPLICATION_URL = process.env.REACT_APP_APPLICATION_URL_PRODUCTION;
    CHATBOT_UI = process.env.REACT_APP_CHATBOT_UI_PRODUCTION;
    KLONIT_WEBSOCKET_URL = process.env.REACT_APP_KLONIT_WEBSOCKET_URL_PRODUCTION || '';
    stripe_pub_key =  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    google_login_api =  process.env.REACT_APP_GOOGLE_LOGIN_KEY;
    facebook_app_id =  process.env.REACT_APP_FACEBOOK_LOGIN_KEY;
    linkedin_client_id = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
    linkedin_redirect_uri = APPLICATION_URL + "/linkedin-callback";
    CUSTOMER_APPLICATION_URL = process.env.REACT_APP_CUSTOMER_URL_PRODUCTION;
}


// Stripe testing

const stripe_publishable_key = stripe_pub_key;


// Customer Portal API URL
let CUSTOMER_PORTAL_API;
if (ENV === "Development") {
    CUSTOMER_PORTAL_API = process.env.REACT_APP_CUSTOMER_PORTAL_API_DEVELOPMENT || 'http://localhost:5007';
} else if (ENV === "Production") {
    CUSTOMER_PORTAL_API = process.env.REACT_APP_CUSTOMER_PORTAL_API_PRODUCTION || '';
} else {
    CUSTOMER_PORTAL_API = process.env.REACT_APP_CUSTOMER_PORTAL_API_TESTING || '';
}

// --- localStorage Keys ---
const SETUP_STEP_LOCAL_KEY = 'klonit_setup_step';
const SETUP_COMPLETE_LOCAL_KEY = 'klonit_setup_complete';


export default backendURL;
export { google_login_api, facebook_app_id, linkedin_client_id, linkedin_redirect_uri, ChatScriptsURL, APPLICATION_URL, stripe_publishable_key, CHATBOT_UI ,SETUP_STEP_LOCAL_KEY , SETUP_COMPLETE_LOCAL_KEY, CUSTOMER_APPLICATION_URL, CUSTOMER_PORTAL_API, KLONIT_WEBSOCKET_URL };
